__turbopack_context__.v({
  "card": "EntityCard-module__tndRAa__card",
  "clickable": "EntityCard-module__tndRAa__clickable",
});
